import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import React from 'react';

import * as colors from '../../../styles/colors';

const Message = React.memo(props => {
  const classes = useStyles(props);
  return (
    <div className={classes.root}>
      <div className={classes.messageContainer}>
        {(!props.isOwn && (props.position === positions.BOTTOM || props.position === positions.SINGLE)) ? (
          <div className={classes.avatar}>
            <Avatar>{props.avatar}</Avatar>
          </div>
        ) : (
          <div className={classes.avatarPlaceholder} />
        )}
        <div className={classes.wrapper}>
          <div className={classes.secondWrapper}>
            <span className={classes.message}>{props.text}</span>
            <span className={classes.timestamp}>
              {props.pending ? 'Sending...' : moment(props.timestamp).format('ddd HH:mm')}
            </span>
          </div>
        </div>
      </div>
      {props.error && (
        <span className={classes.errorMessage} onClick={props.onErrorClick}>
          Message failed to send. Click to retry.
        </span>
      )}
      {/*<span className={classes.time}>{moment(props.timestamp).format('ddd HH:mm')}</span>*/}
    </div>
  );
});

const positions = {
  TOP: 'TOP',
  MIDDLE: 'MIDDLE',
  BOTTOM: 'BOTTOM',
  SINGLE: 'SINGLE'
};

const useStyles = makeStyles(theme => ({
  root: props => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: props.isOwn ? 'flex-end' : undefined,
  }),
  avatar: {
    marginLeft: 8
  },
  avatarPlaceholder: {
    width: 40,
    height: 40,
    alignSelf: 'flex-end',
    marginLeft: 8
  },
  messageContainer: {
    minWidth: 0,
    display: 'flex',
    alignItems: 'flex-end'
  },
  wrapper: {
    display: 'flex',
    flex: 1
  },
  secondWrapper: props => {
    const style = {
      minHeight: '2.5rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginLeft: '0.5rem',
      marginRight: '0.5rem',
      paddingBottom: '0.5rem',
      paddingLeft: '0.75rem',
      paddingRight: '0.75rem',
      paddingTop: '0.5rem',
      borderBottomLeftRadius: '1.25rem',
      borderBottomRightRadius: '1.25rem',
      borderTopLeftRadius: '1.25rem',
      borderTopRightRadius: '1.25rem',
      color: props.isOwn ? 'rgba(256, 256, 256, 0.87)' : 'rgba(0, 0, 0, 0.87)',
      backgroundColor: props.isOwn ? theme.palette.primary.main : 'whitesmoke'
    };
    if (props.position === positions.SINGLE) {
      return style;
    } else {
      if (props.position === positions.TOP) {
        style[`borderBottom${props.isOwn ? 'Right' : 'Left'}Radius`] = '0.25rem';
        style.marginBottom = '0.125rem';
      } else if (props.position === positions.BOTTOM) {
        style[`borderTop${props.isOwn ? 'Right' : 'Left'}Radius`] = '0.25rem';
      } else {
        if (props.isOwn) {
          style[`borderBottom${props.isOwn ? 'Right' : 'Left'}Radius`] = '0.25rem';
          style[`borderTop${props.isOwn ? 'Right' : 'Left'}Radius`] = '0.25rem';
          style.marginBottom = '0.125rem';
        } else {
          style[`borderBottom${props.isOwn ? 'Right' : 'Left'}Radius`] = '0.25rem';
          style[`borderTop${props.isOwn ? 'Right' : 'Left'}Radius`] = '0.25rem';
          style.marginBottom = '0.125rem';
        }
      }
      return style;
    }
  },
  time: {
    marginBottom: '0.125rem',
    marginLeft: '4.25rem',
    marginRight: '4.25rem',
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '0.75rem',
    fontWeight: '500'
  },
  timestamp: props => ({
    alignSelf: props.isOwn ? 'flex-end' : undefined,
    fontSize: 12,
    color: props.isOwn ? 'rgba(256, 256, 256, 0.60)' : 'rgba(0, 0, 0, 0.60)'
  }),
  errorMessage: {
    alignSelf: 'flex-end',
    marginBottom: 2,
    marginLeft: 68,
    marginRight: 8,
    color: 'crimson',
    fontSize: 12,
    fontWeight: '500',
    cursor: 'pointer'
  }
}));

export default Message;